// Aggregates every per-screen translation namespace. Each namespace module
// exports `sv` and `en`. Adding a screen = create ./<ns>.ts and import it here.
import * as ads from './ads'
import * as calendar from './calendar'
import * as claim from './claim'
import * as dashboard from './dashboard'
import * as invite from './invite'
import * as jobDetail from './jobDetail'
import * as jobs from './jobs'
import * as layout from './layout'
import * as login from './login'
import * as membershipSelection from './membershipSelection'
import * as profile from './profile'
import * as quotes from './quotes'
import * as requestDetail from './requestDetail'
import * as requests from './requests'
import * as reviews from './reviews'
import * as services from './services'
import * as staff from './staff'

export const namespaces = {
  ads,
  calendar,
  claim,
  dashboard,
  invite,
  jobDetail,
  jobs,
  layout,
  login,
  membershipSelection,
  profile,
  quotes,
  requestDetail,
  requests,
  reviews,
  services,
  staff,
}
